const constants = {
  BASE_HIT_NUMBER: 8,
  HIT_DICE_SIDES: 12
}
export default constants;
